import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { UaDetail } from '@/api/unitAssessmentAdmin'
import { gradingDraftScope } from '@/hooks/coaching/useGradingDraft'
import type { ManualGradeCredit } from '@/types/coaching'
import { GradingSheet } from './GradingSheet'
import { unitAssessmentRowsOf, type GradingSheetRow } from './gradingRows'

interface Props {
  assessment: UaDetail
  learnerId: number
  canGrade: boolean
  /** 정오답만 저장한다. 기존 학생 답안을 보존하기 위해 answer를 전달하지 않는다. */
  saveGrade: (quizId: string, isCorrect: boolean) => Promise<unknown>
  onSaveSettled?: () => void
  onRequestCoaching?: (quizId: string) => void
}

/** 일반 오늘 수업 단원평가 채점표. 변경한 O/X를 표시 순서대로 저장한다. */
export function UnitAssessmentGradingSheet({
  assessment,
  learnerId,
  canGrade,
  saveGrade,
  onSaveSettled,
  onRequestCoaching,
}: Props) {
  const { t } = useTranslation('coaching')
  const rows = useMemo(() => unitAssessmentRowsOf(assessment), [assessment])

  const saveRow = async (row: GradingSheetRow, value: ManualGradeCredit) => {
    await saveGrade(row.key, value === 1)
  }

  return (
    <GradingSheet
      draftScope={gradingDraftScope.unitAssessment(learnerId, assessment.id)}
      testId="unit-assessment-grading-sheet"
      title={t('unitAssessment.gradingTitle')}
      rows={rows}
      readOnly={!canGrade}
      saveRow={saveRow}
      onSaveSettled={onSaveSettled}
      onRequestCoaching={onRequestCoaching}
      emptyMessage={t('gradingMode.noRows')}
      hidePreviewSolveDescription
    />
  )
}
